import { Component, inject, input, model, signal, ChangeDetectionStrategy } from "@angular/core";
import { AccessControlService } from "@dis/auth";
import type { DisabledReason, FormValueControl, ValidationError, WithOptionalFieldTree } from "@angular/forms/signals";
import { computedWith } from "ngx-signal-operators";
import { injectProjectsAutoComplete } from "@jtms/default-connector/angular";
import {
  projectGetByIdRef,
  type ProjectGetByIdData,
  type ProjectGetByIdVariables,
} from "@dataconnect/realtime-connector";
import { REALTIME_DATA_CONNECT_INJECTOR } from "@dis/firebase";
import { streamDataConnectQuery } from "../../../utils/data-connect.util";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
@Component({
  selector: "lib-project-autocomplete-control",
  imports: [MatAutocompleteModule, MatFormFieldModule, MatInputModule],
  templateUrl: "./project-autocomplete-control.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./project-autocomplete-control.component.css",
})
export class ProjectAutocompleteControl implements FormValueControl<string> {
  // Required
  value = model<string>("");

  inputValue = signal<string>("");

  #debouceInputValue = computedWith(this.inputValue).debounce(500);

  getProject = streamDataConnectQuery<ProjectGetByIdData, ProjectGetByIdVariables>(
    projectGetByIdRef,
    () => (this.value() ? { id: this.value() } : undefined),
    inject(REALTIME_DATA_CONNECT_INJECTOR)
  );

  #access = inject(AccessControlService);
  filteredOptions = injectProjectsAutoComplete(
    () => ({
      query: this.#debouceInputValue(),
      ...this.#access.readScope(),
    }),
    () => ({ enabled: !!this.inputValue() })
  );

  displayFn(project: any | null): string {
    return project ? `${project.projectNumber}` : "";
  }

  // Writable interaction state - control updates these
  touched = model<boolean>(false);
  // Read-only state - form system manages these
  disabled = input<boolean>(false);
  disabledReasons = input<readonly WithOptionalFieldTree<DisabledReason>[]>([]);
  readonly = input<boolean>(false);
  hidden = input<boolean>(false);
  invalid = input<boolean>(false);
  errors = input<readonly ValidationError.WithOptionalFieldTree[]>([]);
}
